const templateRouter = [
	{
		path: '/template',
		name: 'Template',
		component: () => import('../template/BasicTemplate.vue'),
	},
]

export default templateRouter
